import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function getPlaceFacilities(params) {
  return request({
    url: ENDPOINT.PLACE_FACILITIES,
    method: 'get',
    params
  })
}

export function createPlaceFacility(data) {
  return request({
    url: ENDPOINT.PLACE_FACILITIES,
    method: 'post',
    data
  })
}

export function updatePlaceFacility(data) {
  return request({
    url: ENDPOINT.PLACE_FACILITIES,
    method: 'patch',
    data
  })
}

export function deletePlaceFacility(params) {
  return request({
    url: ENDPOINT.PLACE_FACILITIES,
    method: 'delete',
    params: typeof params === 'object' ? params : { id: params }
  })
}
